import {SummaryModel} from "../../../../../../common/entity/summary.model";
import {PermissionsModel} from "../../../../../../common/entity/permissions.model";
import {PaymentRequestSummaryModel} from "../../../api/entity/paymentRequestSummary.model";
import {Moment} from "moment";

export class PaymentRequestReminderSummaryModel implements SummaryModel {
    permissions: PermissionsModel;
    id: number;
    paymentRequest: PaymentRequestSummaryModel;
    date: Moment;
}